export default {
    // --------Title--------
    injectionFields: 'Injection Fields',
    newInjectionField: 'New Injection Field',
    properties: 'Properties',
    detailOfTheInjectionFields: 'Detail of the injection fields',

    // --------MUI--------
    mainProperty: 'Main Property',
    module: 'Module',
    reference: 'Reference',
    fieldType: 'Field Type',
    fieldKey: 'Field Key',
};